import type { ComponentType } from 'react';
import { BuildingOfficeIcon, ComputerDesktopIcon, HomeIcon } from '@heroicons/react/24/outline';
import type { AvailabilityWorkModel } from '../models';
import { AvailabilityWorkModels } from '../models';

export const WORK_MODEL_ICON_MAP: Record<AvailabilityWorkModel, ComponentType<{ className?: string }>> = {
  [AvailabilityWorkModels.Onsite]: BuildingOfficeIcon,
  [AvailabilityWorkModels.Hybrid]: ComputerDesktopIcon,
  [AvailabilityWorkModels.Remote]: HomeIcon,
};
